// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { formatLocalDate } from './localDate';

export type RoundUpdateGameWeight = {
  gameDefinitionId: string;
  weightPercent: number;
};

export type RoundUpdateCourse = {
  id: string;
  name: string;
  address: string;
  lat: number;
  lon: number;
};

export type RoundUpdateMessagePayload = {
  type: 'round.update';
  roundId: string;
  gameDefinitionIds?: string[];
  gameWeights?: RoundUpdateGameWeight[];
  course?: RoundUpdateCourse;
  holesCount?: number;
  playDate?: string;
  name?: string;
};

export const buildRoundUpdateMessage = (args: {
  roundId: string;
  gameDefinitionIds?: string[];
  gameWeights?: RoundUpdateGameWeight[];
  course?: RoundUpdateCourse;
  holesCount?: number;
  playDate?: Date | null;
  name?: string | null;
}): RoundUpdateMessagePayload => {
  const payload: RoundUpdateMessagePayload = {
    type: 'round.update',
    roundId: args.roundId,
  };

  if (args.gameDefinitionIds) {
    payload.gameDefinitionIds = [...args.gameDefinitionIds];
  }

  if (args.gameWeights) {
    payload.gameWeights = args.gameWeights.map((weight) => ({ ...weight }));
  }

  if (args.playDate) {
    payload.playDate = formatLocalDate(args.playDate);
  }

  if (args.course) {
    payload.course = { ...args.course };
  }

  if (args.holesCount === 9 || args.holesCount === 18) {
    payload.holesCount = args.holesCount;
  }

  if (args.name != null) {
    payload.name = args.name;
  }

  return payload;
};
